import React, {Component} from 'react';
import { FormattedMessage } from 'react-intl';
import ScrollAnimation from 'react-animate-on-scroll';
import Button from './../../components/button/Button';

import AppLogo from './../../assets/img/appLogo.png';
import AppStoreIcon from './../../assets/img/appStore.png';
import PlayStoreIcon from './../../assets/img/playStore.png';
import AndroidIcon from './../../assets/img/androidIcon.png';
import AppleIcon from './../../assets/img/appleIcon.png';

import styles from './LandPageDesktop.module.css';
import StoreUrls from './../../assets/json/storeUrls';

class LandPageDesktopScreen extends Component {

    constructor(props){
        super(props);
        this.goToLogin = this.goToLogin.bind(this);

        window.scrollTo(0,0);

        this.renderEnterButton = this.renderEnterButton.bind(this);
    }

    goToLogin(){
        this.props.history.push({
            pathname: '/login',
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToAppStore(){
        window.open(StoreUrls.appStore);
    }

    goToPlayStore(){
        window.open(StoreUrls.googlePlay);
    }

    renderEnterButton(){
        if(this.props.mobile){
            return (
                <div className={styles.enterButtonContainer}>
                    <Button onClick={this.goToLogin} styleType="reverse" className={styles.enterButton}>
                        <FormattedMessage id="enter" />
                    </Button>
                </div>
            );
        }
    }

    render(){
        let storeIcon, storeIconFirst;

        storeIconFirst = (
            <div className={styles.downloadSection}>
                <img src={AndroidIcon} className={styles.androidIconLeft} onClick={this.goToPlayStore} />
                <img src={AppleIcon} className={styles.appleIconLeft} onClick={this.goToAppStore} />
            </div>
        );

        storeIcon = (
            <div className={styles.downloadSection}>
                <img src={AndroidIcon} className={styles.androidIcon} onClick={this.goToPlayStore} />
                <img src={AppleIcon} className={styles.appleIcon} onClick={this.goToAppStore} />
            </div>
        );

        return (
            <div className={styles.fullPage}>

                <div className={[styles.section, styles.sectionYellow].join(' ')}>
                    <div>
                        {this.renderEnterButton()}
                        <div className={styles.appLogoContainer}>
                            <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" offset={0}>
                                <img src={AppLogo} className={styles.appLogo} />
                            </ScrollAnimation>
                        </div>
                        <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" delay={500} offset={0}>
                            <div className={[styles.titleSection, styles.title1].join(' ')}>
                                <span className={styles.title}>
                                    <FormattedMessage id="landPageWelcome" />
                                </span>
                            </div>
                            <div>
                                <div className={[styles.descriptionSection, styles.description1].join(' ')}>
                                    <span className={styles.description}>
                                        <FormattedMessage id="downloadAvaliable" />
                                    </span>
                                </div>
                                {storeIconFirst}
                            </div>
                        </ScrollAnimation>
                    </div>
                    <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" delay={800} offset={0}>
                        <div className={styles.image1}>
                            <img src={require('./../../assets/img/landpage1.png')}/>
                        </div>
                    </ScrollAnimation>
                </div>

                <div className={[styles.section, styles.sectionBlue].join(' ')}>
                    <div>
                        <div className={styles.image2}>
                            <img src={require('./../../assets/img/landpage2.png')}/>
                        </div>
                    </div>
                    <div>
                        <div className={[styles.titleSection, styles.titlePadding, styles.title2].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.title}>
                                    <FormattedMessage id="landPageEvents" />
                                </span>
                            </ScrollAnimation>
                        </div>
                        <div className={[styles.descriptionSection, styles.description2].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.description}>
                                    <FormattedMessage id="landPageEventsDesc" />
                                </span>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className={[styles.section, styles.sectionWhite].join(' ')}>
                    <div>
                        <div className={[styles.titleSection, styles.titlePadding, styles.title3].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.title}>
                                    <FormattedMessage id="landPageMap" />
                                </span>
                            </ScrollAnimation>
                        </div>
                        <div className={[styles.descriptionSection, styles.description3].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.description}>
                                    <FormattedMessage id="landPageMapDesc" />
                                </span>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" offset={80}>
                        <div className={styles.image3}>
                            <img src={require('./../../assets/img/landpage3Desktop.png')}/>
                        </div>
                    </ScrollAnimation>
                </div>

                <div className={[styles.section, styles.sectionYellow].join(' ')}>
                    <div>
                        <div className={styles.image4}>
                            <img src={require('./../../assets/img/landpage4Desktop.png')}/>
                        </div>
                    </div>
                    <div>
                        <div className={[styles.titleSection, styles.titlePadding, styles.title4].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.title}>
                                    <FormattedMessage id="landPageExperience" />
                                </span>
                            </ScrollAnimation>
                        </div>
                        <div className={[styles.descriptionSection, styles.description4].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.description}>
                                    <FormattedMessage id="landPageExperienceDesc" />
                                </span>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className={[styles.section, styles.sectionWhite].join(' ')}>
                    <div>
                        <div className={[styles.titleSection, styles.titlePadding, styles.title6].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.title}>
                                    <FormattedMessage id="landPageAudio" />
                                </span>
                            </ScrollAnimation>
                        </div>
                        <div className={[styles.descriptionSection, styles.description6].join(' ')}>
                            <ScrollAnimation animateIn="fadeInDown" animateOut="fadeOutUp" offset={80}>
                                <span className={styles.description}>
                                    <FormattedMessage id="landPageAudioDesc" />
                                </span>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut" offset={80}>
                        <div className={styles.image6}>
                            <img src={require('./../../assets/img/landpage6Desktop.png')}/>
                        </div>
                    </ScrollAnimation>
                </div>

                <div className={[styles.section, styles.sectionBlue].join(' ')}>
                    <div>
                        <div className={styles.image5}>
                            <img src={require('./../../assets/img/landpage5.png')}/>
                        </div>
                    </div>
                    <div>
                        <div className={[styles.titleSection, styles.titlePadding, styles.title5].join(' ')}>
                            <span className={styles.title}>
                                <FormattedMessage id="downloadApp" />
                            </span>
                        </div>
                        <div className={[styles.descriptionSection, styles.description5].join(' ')}>
                            <span className={styles.description}>
                                <FormattedMessage id="downloadAvaliable" />
                            </span>
                        </div>
                        {storeIcon}
                    </div>
                </div>
            </div>
        );
    }

}

export default LandPageDesktopScreen;